import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import car1 from "../../assets/assets/images/car_detail/car_detail_main.png";
import { MdDoubleArrow, MdSentimentVeryDissatisfied } from "react-icons/md";
import OrdersCard from "./OrdersCard";
import { cleanOrdersStatus, fetchOrders } from "../../redux/Slice/carSlice";
import { Pagination } from "@mui/material";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import noData from "../../assets/no-data.png";
const Index = () => {
  const userDetail = useSelector((state) => state?.auth?.userDetail);
  const OrdersData = useSelector((state) => state?.car?.OrdersData);
  const OrdersStatus = useSelector((state) => state?.car?.OrdersStatus);
  const loginDetail = useSelector((state) => state?.auth?.loginId);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(6); // Number of items per page

  useEffect(() => {
    if (!loginDetail) {
      navigate("/login");
    }
  }, []);

  useEffect(() => {
    if (userDetail?.data?._id) {
      dispatch(fetchOrders({ userId: userDetail?.data?._id }));
    }
  }, [dispatch, userDetail?.data?._id]);

  // Logic to get current items based on pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = OrdersData?.slice(indexOfFirstItem, indexOfLastItem);
  useEffect(() => {
    if (OrdersStatus?.success === true) {
      toast(OrdersStatus?.message);
      dispatch(fetchOrders({ userId: userDetail?.data?._id }));
      dispatch(cleanOrdersStatus());
    }
  }, [OrdersStatus]);
  // Change page
  const handlePageChange = (event, page) => {
    setCurrentPage(page);
  };

  return (
    <div className="container-fluid pb-6 px-0">
      <div className="container">
        <div className="d-flex flex-row fs-2 accentColor align-items-center py-2 mb-2">
          <span className="lh-0">
            <MdDoubleArrow />
          </span>
          <span className="font">Orders</span>
        </div>
        <div className="row">
          {currentItems && currentItems.length > 0 ? (
            currentItems.map((data) => (
              <div key={data?._id} className="col-md-6 col-lg-4 m-0 mb-4">
                <OrdersCard
                  bookingId={data?._id}
                  bookingData={data}
                  carImage={data?.car?.frontImage}
                  carLocation={data?.car?.carLocation}
                  carName={data?.car?.maker?.carMake}
                  tripStart={data?.pickUpDateandTime}
                  tripEnd={data?.returnDateandTime}
                  carPrice={data?.car?.pricePerDay}
                  bookingStatus={data?.status}
                />
              </div>
            ))
          ) : (
            <div
              className="d-flex align-items-center justify-content-center"
              style={{ minHeight: "200px" }}
            >
              {/* <MdSentimentVeryDissatisfied
                style={{ fontSize: "48px", marginRight: "10px" }}
              /> */}
              {/* <p className="accentColor">No orders yet.</p> */}
              <div className="d-flex justify-content-center">
                {/* <h2 className="text-center font secondaryColor mt-3">
                    No data found
                  </h2> */}
                <img src={noData} alt="no data found" className="nofoundImg" />
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="mt-4 text-end">
        {currentItems && currentItems.length > 0 && (
          <Pagination
            count={Math.ceil(OrdersData.length / itemsPerPage)}
            shape="rounded"
            onChange={handlePageChange}
          />
        )}
      </div>
    </div>
  );
};

export default Index;
